/* v2-shared-cart.js - landing page for a shared bag or wishlist (/pages/shared-bag?b=...).
   Decodes the link, validates it, and rebuilds it for the visitor as a guest.
   Bag link: "Replace my bag" / "Add to my bag" when the visitor already has items.
   Wishlist link: add to bag, replace the bag, add to wishlist, or replace the wishlist. */
(function () {
var root = document.querySelector('[data-v2sb]');
if (!root || root.__v2sb) return;
root.__v2sb = true;

var MAX_LINES = 20, MAX_WISH = 30, MAX_QTY = 99;
var ATTR_ALLOW = ['Packaging'];
var WISH_KEYS = ['wishlist-ids', 'wishlist-titles', 'wishlist-urls', 'wishlist-materials', 'wishlist-prices', 'wishlist-images'];
var PRODUCT_URL = /^(\/[a-z]{2}(-[a-zA-Z]{2,4})?)?\/products\/[A-Za-z0-9._~%-]+(\?variant=\d+)?$/;
function str(n) { return root.getAttribute('data-' + n) || ''; }
function q(sel) { return root.querySelector(sel); }
function show(name, msg) {
  Array.prototype.forEach.call(root.querySelectorAll('[data-v2sb-state]'), function (el) {
    el.hidden = el.getAttribute('data-v2sb-state') !== name;
  });
  if (msg != null) {
    var m = root.querySelector('[data-v2sb-state="' + name + '"] [data-v2sb-msg]');
    if (m) m.textContent = msg;
  }
}

function fromB64u(s) {
  s = s.replace(/-/g, '+').replace(/_/g, '/');
  while (s.length % 4) s += '=';
  var bin = atob(s), out = new Uint8Array(bin.length);
  for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
function gunzip(bytes) {
  if (typeof DecompressionStream === 'undefined') return Promise.reject(new Error('no gzip'));
  var ds = new DecompressionStream('gzip');
  var w = ds.writable.getWriter();
  w.write(bytes); w.close();
  return new Response(ds.readable).arrayBuffer().then(function (b) { return new Uint8Array(b); });
}
function decode(param) {
  try {
    var kind = param.charAt(0), bytes = fromB64u(param.slice(1));
    var get = kind === 'g' ? gunzip(bytes) : kind === 'p' ? Promise.resolve(bytes) : Promise.reject(new Error('kind'));
    return get.then(function (b) { return JSON.parse(new TextDecoder().decode(b)); });
  } catch (e) { return Promise.reject(e); }
}

/* Link format v2 sends property names from this list as numbers, and properties as a flat [name, value, ...] list.
   Same list as v2-cart-share.js: only ever add to the end, never reorder. Format v1 links (properties as an object, a full
   product path and a title per wishlist piece) are still read, so links that were already shared keep working. */
var KEYS = ['Stone', 'Metal', 'Gauge', '_Bar Length', '_Fitting', 'Fitting', 'Bar Length', 'Birthstone', 'Connector',
  'Material', 'Packaging', 'May be eligible for bundle discount', '_v2', 'Delivery', 'Ships'];
function unflat(list) {
  if (!Array.isArray(list)) return null;
  var out = {};
  for (var i = 0; i + 1 < list.length && i < 60; i += 2) {
    var k = typeof list[i] === 'number' ? KEYS[list[i]] : list[i];
    if (typeof k !== 'string') continue;
    out[k] = list[i + 1];
  }
  return out;
}

/* Never trust the link: check every field and rebuild a clean object. */
function cleanProps(props) {
  if (!props || typeof props !== 'object' || Array.isArray(props)) return null;
  var clean = {};
  Object.keys(props).slice(0, 30).forEach(function (k) {
    var v = props[k];
    if (typeof v !== 'string' && typeof v !== 'number') return;
    if (/^__shopify_/.test(k) || k.length > 100) return;
    clean[k] = String(v).slice(0, 500);
  });
  return Object.keys(clean).length ? clean : null;
}
function validateCart(o) {
  var v2 = o && o.v === 2;
  if (!o || (o.v !== 1 && !v2) || !Array.isArray(o.i) || !o.i.length || o.i.length > MAX_LINES) return null;
  var items = [];
  for (var n = 0; n < o.i.length; n++) {
    var r = o.i[n];
    if (!Array.isArray(r)) return null;
    var id = r[0], qty = r[1];
    if (!(Number.isInteger(id) && id > 0) || !(Number.isInteger(qty) && qty >= 1 && qty <= MAX_QTY)) return null;
    var line = { id: id, quantity: qty };
    var props = cleanProps(v2 ? unflat(r[2]) : r[2]);
    if (props) line.properties = props;
    var sp = r[3];
    if (Number.isInteger(sp) && sp > 0) line.selling_plan = sp;
    items.push(line);
  }
  var attrs = {};
  var a = v2 ? unflat(o.a) : o.a;
  if (a && typeof a === 'object') {
    ATTR_ALLOW.forEach(function (k) {
      if (typeof a[k] === 'string' && a[k].length <= 100) attrs[k] = a[k];
    });
  }
  return { kind: 'cart', items: items, attrs: attrs };
}
/* "handle" or "/fr|handle" -> { path prefix, handle }, or null if it is not a plain product handle */
function parseRef(ref) {
  if (typeof ref !== 'string' || ref.length > 300) return null;
  var parts = ref.split('|'), prefix = '', handle = parts[parts.length - 1];
  if (parts.length > 2) return null;
  if (parts.length === 2) {
    prefix = parts[0];
    if (!/^\/[a-z]{2}(-[a-zA-Z]{2,4})?$/.test(prefix)) return null;
  }
  if (!/^[A-Za-z0-9._~%-]+$/.test(handle)) return null;
  return { prefix: prefix, handle: handle };
}
function validateWishV2(o) {
  if (!o || o.v !== 2 || o.k !== 'w' || !Array.isArray(o.i) || !o.i.length || o.i.length > MAX_WISH) return null;
  var items = [], seen = {};
  for (var n = 0; n < o.i.length; n++) {
    var r = o.i[n];
    if (!Array.isArray(r)) return null;
    var id = r[0], ref = parseRef(r[1]);
    if (!(Number.isInteger(id) && id > 0) || !ref) return null;
    if (seen[id]) continue;
    seen[id] = true;
    var extras = [];
    if (Array.isArray(r[2])) {
      r[2].slice(0, 10).forEach(function (x) {
        if (Array.isArray(x) && typeof x[0] === 'string' && typeof x[1] === 'string' && x[0] && x[1]) {
          extras.push([x[0].slice(0, 100), x[1].slice(0, 200)]);
        }
      });
    }
    var props = cleanProps(unflat(r[3])) || {};
    if (!props._v2) props._v2 = '1';   /* a wishlist piece always moves to the bag as a v2 line */
    items.push({ id: id, url: ref.prefix + '/products/' + ref.handle + '?variant=' + id, handle: ref.handle, title: '', extras: extras, props: props });
  }
  return { kind: 'wish', items: items };
}
function validateWish(o) { return o && o.v === 2 ? validateWishV2(o) : validateWishV1(o); }

function validateWishV1(o) {
  if (!o || o.v !== 1 || o.k !== 'w' || !Array.isArray(o.i) || !o.i.length || o.i.length > MAX_WISH) return null;
  var items = [], seen = {};
  for (var n = 0; n < o.i.length; n++) {
    var r = o.i[n];
    if (!Array.isArray(r)) return null;
    var id = r[0], url = r[1];
    if (!(Number.isInteger(id) && id > 0) || typeof url !== 'string' || !PRODUCT_URL.test(url)) return null;
    if (seen[id]) continue;
    seen[id] = true;
    var title = typeof r[2] === 'string' ? r[2].replace(/[,<>]/g, ' ').trim().slice(0, 200) : '';
    var extras = [];
    if (Array.isArray(r[3])) {
      r[3].slice(0, 10).forEach(function (x) {
        if (Array.isArray(x) && typeof x[0] === 'string' && typeof x[1] === 'string' && x[0] && x[1]) {
          extras.push([x[0].slice(0, 100), x[1].slice(0, 200)]);
        }
      });
    }
    items.push({ id: id, url: url, title: title, extras: extras, props: cleanProps(r[4]) });
  }
  return { kind: 'wish', items: items };
}

function post(url, body) {
  return fetch(url, {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body || {})
  });
}

/* Returns { added, failed }. Tries all lines at once; if Shopify rejects the batch, tries line by line. */
function addItems(items) {
  return post('/cart/add.js', { items: items }).then(function (r) {
    if (r.ok) return { added: items.length, failed: 0 };
    var added = 0, failed = 0;
    return items.reduce(function (chain, it) {
      return chain.then(function () {
        return post('/cart/add.js', { items: [it] }).then(function (rr) { if (rr.ok) added++; else failed++; });
      });
    }, Promise.resolve()).then(function () { return { added: added, failed: failed }; });
  });
}

function goShop(tab) {
  try {
    sessionStorage.setItem('v2:openBag', String(Date.now()));
    if (tab) sessionStorage.setItem('v2:openTab', tab);
  } catch (e) {}
  location.replace(str('shop-url') || '/');
}

/* ---- bag link ---- */

function runCart(plan, mode, cart) {
  show('loading');
  var start = mode === 'replace' ? post('/cart/clear.js') : Promise.resolve();
  return start.then(function () {
    return addItems(plan.items);
  }).then(function (res) {
    if (!res.added) { show('error', str('none')); return; }
    var attrs = plan.attrs;
    var needAttr = Object.keys(attrs).length && (mode === 'replace' || !cart || !cart.attributes || !cart.attributes.Packaging);
    var next = needAttr ? post('/cart/update.js', { attributes: attrs }) : Promise.resolve();
    return next.then(function () {
      if (res.failed) { done(str('partial'), false); return; }
      goShop();
    });
  });
}

/* ---- wishlist link ---- */

function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
function lsSet(k, v) { try { window.localStorage.setItem(k, v); return true; } catch (e) { return false; } }
function savedList(k) {
  var raw = lsGet(k);
  return raw ? raw.split(',').filter(function (x) { return x !== '' && x !== 'null'; }) : [];
}

/* Same storage the heart buttons and the drawer use: six parallel comma lists plus the saved extra choices. */
function saveWish(plan, mode) {
  var lists = {};
  WISH_KEYS.forEach(function (k) { lists[k] = mode === 'replace' ? [] : savedList(k); });
  var extras = {};
  if (mode !== 'replace') { try { extras = JSON.parse(lsGet('v2-wish-extras') || '{}') || {}; } catch (e) { extras = {}; } }
  var have = lists['wishlist-ids'].slice();
  var added = 0;
  plan.items.forEach(function (it) {
    if (have.indexOf(String(it.id)) > -1) return;
    have.push(String(it.id));
    lists['wishlist-ids'].push(String(it.id));
    lists['wishlist-titles'].push(it.title || ' ');
    lists['wishlist-urls'].push(it.url);
    lists['wishlist-materials'].push(' ');
    lists['wishlist-prices'].push(' ');
    lists['wishlist-images'].push(' ');
    if (it.extras.length) extras[String(it.id)] = it.extras;
    added++;
  });
  var ok = WISH_KEYS.every(function (k) {
    return lsSet(k, lists[k].length ? lists[k].join(',') + ',' : '');
  });
  ok = lsSet('v2-wish-extras', JSON.stringify(extras)) && ok;
  return ok ? added : -1;
}

function runWishBag(plan, mode) {
  show('loading');
  var items = plan.items.map(function (it) {
    var props = it.props ? Object.assign({}, it.props) : { _v2: '1' };
    /* the ship-by line is worked out now, from today's date, by the drawer's own rule */
    if (typeof window.__v2WishShipFor === 'function') {
      var ship = window.__v2WishShipFor(props);
      if (ship) props.Ships = ship;
    }
    return { id: it.id, quantity: 1, properties: props };
  });
  var start = mode === 'replace' ? post('/cart/clear.js') : Promise.resolve();
  return start.then(function () { return addItems(items); }).then(function (res) {
    if (!res.added) { show('error', str('none')); return; }
    if (res.failed) { done(str('partial'), false); return; }
    goShop();
  });
}

/* v2 links do not carry titles: read them from the products (best effort, a blank is fine), same cleaning as v1 titles */
function fillTitles(plan) {
  var need = plan.items.filter(function (it) { return !it.title && it.handle; });
  if (!need.length) return Promise.resolve();
  return Promise.all(need.map(function (it) {
    return fetch('/products/' + it.handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && typeof p.title === 'string') it.title = p.title.replace(/[,<>]/g, ' ').trim().slice(0, 200); })
      .catch(function () {});
  }));
}

function runWishSave(plan, mode) {
  show('loading');
  return fillTitles(plan).then(function () {
    var n = saveWish(plan, mode);
    if (n < 0) { show('error', str('error')); return; }
    done(str('saved'), true);
  });
}

function done(msg, wish) {
  show('done', msg);
  var v = q('[data-v2sb-view]'), w = q('[data-v2sb-view-wish]');
  if (v) v.hidden = !!wish;
  if (w) w.hidden = !wish;
}

function art(kind) {
  Array.prototype.forEach.call(root.querySelectorAll('[data-v2sb-art]'), function (im) {
    im.hidden = im.getAttribute('data-v2sb-art') !== kind;
  });
}

function fail(e) { show('error', e && e.message === 'kind' ? str('invalid') : str('error')); }

var param = new URLSearchParams(location.search).get('b');
if (!param) { show('error', str('invalid')); return; }

decode(param).catch(function () { throw new Error('kind'); }).then(function (o) {
  var plan = o && o.k === 'w' ? validateWish(o) : validateCart(o);
  if (!plan) { show('error', str('invalid')); return; }
  return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
    art(plan.kind === 'wish' ? 'wish' : 'bag');
    if (plan.kind === 'wish') {
      var h = q('[data-v2sb-heading]');
      if (h && str('wish-heading')) h.textContent = str('wish-heading');
      show('wprompt');
      var bagHas = cart.item_count > 0, wishHas = savedList('wishlist-ids').length > 0;
      q('[data-v2sb-wbag-replace]').hidden = !bagHas;
      q('[data-v2sb-wsave-replace]').hidden = !wishHas;
      q('[data-v2sb-wbag]').onclick = function () { runWishBag(plan, 'add').catch(fail); };
      q('[data-v2sb-wbag-replace]').onclick = function () { runWishBag(plan, 'replace').catch(fail); };
      q('[data-v2sb-wsave]').onclick = function () { runWishSave(plan, 'add').catch(fail); };
      q('[data-v2sb-wsave-replace]').onclick = function () { runWishSave(plan, 'replace').catch(fail); };
      return;
    }
    if (!cart.item_count) return runCart(plan, 'add', cart);
    show('prompt');
    q('[data-v2sb-replace]').onclick = function () { runCart(plan, 'replace', cart).catch(fail); };
    q('[data-v2sb-add]').onclick = function () { runCart(plan, 'add', cart).catch(fail); };
  });
}).catch(fail);

Array.prototype.forEach.call(root.querySelectorAll('[data-v2sb-view]'), function (b) {
  b.addEventListener('click', function () { goShop(); });
});
Array.prototype.forEach.call(root.querySelectorAll('[data-v2sb-view-wish]'), function (b) {
  b.addEventListener('click', function () { goShop('wish'); });
});
})();
